var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompliancePdfFile(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 210,
    viewBox: "0 0 201 210",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.4%",
    y: "-3.2%",
    width: "107.2%",
    height: "106.5%",
    filterUnits: "objectBoundingBox",
    id: "kred1b7j9a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.300721 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#kred1b7j9a)",
    fill: "#F0EFEF",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0h135.207l51.101 51.101V196a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 38.708,
    height: 38.626,
    rx: 4,
    transform: "translate(80.847 80.07)",
    fill: "#D50000",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.476 100.567c-.627-.537-1.255-1.21-1.972-1.927-.493-.537-1.03-1.3-1.479-2.106.852-2.913 1.255-5.691.359-7.036-.404-.627-1.03-.94-1.838-.94-.896 0-1.568.403-1.882 1.164-.717 1.614.359 4.571 1.658 6.991a57.453 57.453 0 0 1-1.344 3.81 34.123 34.123 0 0 1-1.03 2.24c-3.676 1.434-5.916 3.048-6.23 4.571-.134.718.09 1.345.717 1.838.359.269.762.448 1.21.448.18 0 .359-.045.538-.09 1.703-.448 3.54-2.957 4.885-5.512a25.448 25.448 0 0 1 2.778-.896 33.785 33.785 0 0 1 3.227-.807c1.747 1.39 3.226 2.151 4.526 2.151.986.045 1.703-.313 2.375-.986.986-.985.583-1.837.448-2.061-.806-1.255-3.271-1.524-6.946-.852zm-11.741 7.395a.443.443 0 0 1-.359-.045c-.18-.134-.18-.224-.134-.314.09-.537 1.12-1.523 3.36-2.599-1.075 1.613-2.15 2.779-2.867 2.958zm6.363-17.612c.045-.09.09-.224.448-.224.314 0 .449.134.538.224.404.582.359 2.061-.134 4.033-.762-1.703-1.165-3.316-.852-4.033zm1.255 11.203-1.344.404c.134-.314.269-.628.403-.897.314-.851.672-1.702.986-2.599.358.493.672.941.986 1.255.403.448.806.851 1.21 1.255-.717.18-1.48.358-2.24.582zm9.456.807c-.314.359-.717.493-1.21.493-.672 0-1.479-.314-2.42-.941 2.6-.359 4.078-.09 3.63.448z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.207 5 51.101 51.101h-47.101a4 4 0 0 1-4-4V5z",
    fill: "#E05F5F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliancePdfFile);
export default __webpack_public_path__ + "static/media/compliance-pdf-file.0af6af9d.svg";
export { ForwardRef as ReactComponent };